module.exports = __webpack_public_path__ + "static/img/s43.bcf6fb5c.png";